import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

export const Input = styled.input`
  background: ${getToken('color-neutral-white')};
  border: 1px solid ${getToken('color-neutral-lighter')};
  border-radius: 2px;
  color: ${getToken('color-neutral-darker')};
  float: none;
  font-family: ${getToken('font-family-default')};
  font-size: 14px;
  font-weight: 500;
  outline: 0;
  padding: 9px 10px;
  width: 100%;

  &:focus {
    border: 1px solid ${getToken('color-primary')};
  }
`

export default Input
